import React, { useContext, useMemo } from 'react';
import EditText from '../crm/shared/field_inputs/text/EditText';
import EditNumber from '../crm/shared/field_inputs/number/EditNumber';
import { DataContext as SharedDataContext } from '../../stores/crm-store';
import { HandleDuplicateCourse, HandlePatchCourse } from './requests/CourseRequests';
import { MoveBookings } from './requests/BookingRequests';
import { createGetSuggestionsFromApiUrl } from '../crm/shared/field_inputs/HelpMethods';
import { navigate } from 'hookrouter';
import { GetTeachersByIds } from './requests/TeacherRequests';
import ExlEditItemList from './field_inputs/item/ExlEditItemList';
import { bookingStatusOptions, courseCategoryOptions, courseLanguageOptions, getOptionsObjectValues, getOptionsObjectValue, courseFormatOptions } from './shared/translations';
import EditSelect from '../crm/shared/field_inputs/select/EditSelect';
import ExlFormModal from './shared/ExlFormModal';
import ExlEditDraft from './field_inputs/ExlEditDraft';
import { courseFormatComponentsFilter } from './CourseHelperFunctions';
import Checkbox from '../Checkbox';
import { useTranslation } from 'react-i18next';
import { COURSE_MODALS_ADDRESS_LABEL, COURSE_MODALS_BOOK_EXCEEDS_MAX_NUM_VALI, COURSE_MODALS_CATEGORY_LABEL, COURSE_MODALS_DESCRIPTION_LABEL, COURSE_MODALS_EMAIL_NOTIF_LABEL, COURSE_MODALS_FORMAT_LABEL, COURSE_MODALS_LABEL, COURSE_MODALS_LANG_LABEL, COURSE_MODALS_MAX_BOOKINGS_LABEL, COURSE_MODALS_MAX_RESERVES_LABEL, COURSE_MODALS_MEET_LINK_LABEL, COURSE_MODALS_NAME_LABEL, COURSE_MODALS_NO_ADDRESS_VALI, COURSE_MODALS_NO_CATE_VALI, COURSE_MODALS_NO_FORMAT_VALI, COURSE_MODALS_NO_LANG_VALI, COURSE_MODALS_NO_MAX_BOOK_VALI, COURSE_MODALS_NO_NAME_VALI, COURSE_MODALS_NO_STATUS_VALI, COURSE_MODALS_NO_TEACHER_VALI, COURSE_MODALS_RES_EXCEEDS_MAX_NUM_VALI, COURSE_MODALS_STATUS_LABEL, COURSE_MODALS_TEACHER_LABEL, COURSE_MODALS_TO_HIGH_MAX_BOOK_VALI, COURSE_MODALS_TO_HIGH_MAX_RES_VALI, COURSE_MODALS_TO_LONG_NAME_VALI, COURSE_MODALS_TO_LOW_MAX_BOOK_VALI, DUPLICATE_COURSE_LABEL, DUPLICATE_COURSE_OL_BOOKING_WARN, EDIT_COURSE_LABEL } from '../../i18n/keyConstants';



const DuplicateCourse = ({ updateCourse, open, onClose }) => {
    const { dispatch: sharedDispatch } = useContext(SharedDataContext);
    // TODO: Look over this, do wee need to change status for some bookings here?
    const reserveBookings = updateCourse.bookings.filter((booking) =>
        booking.status === bookingStatusOptions.Reserve.value);
    const { t } = useTranslation(['courseModals', 'dupilcateCourse']);


    const defaultFormValues = useMemo(() => ({
        name: updateCourse.name,
        teachers: updateCourse.teachers,
        description: updateCourse.description,
        maxNumBookings: updateCourse.maxNumBookings,
        maxNumReserves: updateCourse.maxNumReserves,
        bookings: reserveBookings,
        category: getOptionsObjectValue(courseCategoryOptions, updateCourse.category),
        language: getOptionsObjectValue(courseLanguageOptions, updateCourse.language),
        location: updateCourse.location,
        meetingLink: updateCourse.meetingLink,
        description: updateCourse.description,
        courseFormat: getOptionsObjectValue(courseFormatOptions, updateCourse.courseFormat),
        sendEmailNotifications: updateCourse.sendEmailNotifications
    }), []);



    const formComponents = [
        {
            propName: 'name',
            label: t(COURSE_MODALS_NAME_LABEL),
            validate: (v) => (!v || !v.length ? t(COURSE_MODALS_NO_NAME_VALI) : v.length > 60 ? t(COURSE_MODALS_TO_LONG_NAME_VALI) : ''),
            component: <EditText />,
        },
        {
            propName: 'teachers',
            label: t(COURSE_MODALS_TEACHER_LABEL),
            validate: (v) => (!v || v.length < 1 ? t(COURSE_MODALS_NO_TEACHER_VALI) : ''),
            component:
                <ExlEditItemList
                    iconName='teacher'
                    isClearable
                    getSuggestions={createGetSuggestionsFromApiUrl('/api/exlTeacherFront/getTeacherSuggestions')}

                />
        },
        {
            propName: 'description',
            label: t(COURSE_MODALS_DESCRIPTION_LABEL),
            component: <ExlEditDraft />
        },
        {
            propName: 'maxNumBookings',
            label: t(COURSE_MODALS_MAX_BOOKINGS_LABEL),
            validate: (v) => (!v ? t(COURSE_MODALS_NO_MAX_BOOK_VALI) : v > 250 ? t(COURSE_MODALS_TO_HIGH_MAX_BOOK_VALI) : v <= 0 ? t(COURSE_MODALS_TO_LOW_MAX_BOOK_VALI) : ''),
            component: <EditNumber />,
        },
        {
            propName: 'maxNumReserves',
            label: t(COURSE_MODALS_MAX_RESERVES_LABEL),
            validate: (v) => (v > 250 ? t(COURSE_MODALS_TO_HIGH_MAX_RES_VALI) : ''),
            component: <EditNumber />,
        },
        {
            propName: 'category',
            label: t(COURSE_MODALS_CATEGORY_LABEL),
            validate: (v) => (!v ? t(COURSE_MODALS_NO_CATE_VALI) : ''),
            component: <EditSelect options={getOptionsObjectValues(courseCategoryOptions)} />
        },
        {
            propName: 'language',
            label: t(COURSE_MODALS_LANG_LABEL),
            validate: (v) => (!v ? t(COURSE_MODALS_NO_LANG_VALI) : ''),
            component: <EditSelect options={getOptionsObjectValues(courseLanguageOptions)} />
        },
        {
            propName: 'courseFormat',
            label: t(COURSE_MODALS_FORMAT_LABEL),
            validate: (v) => (!v ? t(COURSE_MODALS_NO_FORMAT_VALI) : ''),
            component: <EditSelect options={getOptionsObjectValues(courseFormatOptions)} />
        },
        {
            propName: 'location',
            label: t(COURSE_MODALS_ADDRESS_LABEL),
            validate: (v) => (!v || !v.length ? t(COURSE_MODALS_NO_ADDRESS_VALI) : ''),
            component: <EditText />,
        },
        {
            propName: 'meetingLink',
            label: t(COURSE_MODALS_MEET_LINK_LABEL),
            component: <EditText />,
        },
        {
            propName: 'sendEmailNotifications',
            label: '',
            component:
                    <Checkbox
                        usedInExl={true}
                        defaultChecked={updateCourse.sendEmailNotifications}
                        label={t(COURSE_MODALS_EMAIL_NOTIF_LABEL)}
                    />
        },

    ];
    function addBookingFromEmpId(empId) {
        let booking = {};
        booking.CoaEmpId = empId;
        return booking;
    }
    function updateAllBookings(course) {
        let bookings = [];

        for (const booking of course.bookings) {

            if (booking.id.length === 3) {

                let newBooking = addBookingFromEmpId(booking.id);
                bookings.push(newBooking);
            }
            else {
                bookings.push(booking);
            }
        }
        return bookings;
    }

    const filterComponents = (formValues) =>
        formComponents.filter((component) =>
            courseFormatComponentsFilter(formValues?.courseFormat?.value, component)
        )

    async function handleAdd(course) {
        course.category = course.category.value;
        course.language = course.language.value;
        course.courseFormat = course.courseFormat.value;
        course.maxNumReserves = course.maxNumReserves ? course.maxNumReserves : 0;

        const teacherIds = course.teachers.map((teacher) => teacher.id);
        course.teachers = await GetTeachersByIds(teacherIds);

        var stashedBookings = course.bookings;
        course.bookings = null;

        switch (course.courseFormat) {
            case 0:
                course.location = null;
                break;
            case 1:
                course.meetingLink = null;
                break;
        }

        var duplicatedCourse = await HandleDuplicateCourse(course);
        duplicatedCourse.bookings = stashedBookings;
        let updateBookingsResponse = updateAllBookings(duplicatedCourse);
        let updateBookingsIds = updateBookingsResponse.map((booking) => booking.coaEmpId);

        var newBookings = await MoveBookings(duplicatedCourse.id, updateCourse.id, updateBookingsIds);
        if (duplicatedCourse.bookings.length !== newBookings.data.length) {
            sharedDispatch({ type: 'SHOW_GENERIC_EXL_ERROR_TOAST', payload: t(DUPLICATE_COURSE_OL_BOOKING_WARN) });
        }
        
        return { success: !!duplicatedCourse, course: duplicatedCourse};
    }

    return (
        <ExlFormModal
            open={open}
            onClose={onClose}
            description={t(DUPLICATE_COURSE_LABEL, {ns: 'duplicateCourse'})}
            defaultFormValues={defaultFormValues}
            defaultFormComponents={formComponents}
            handleAdd={handleAdd}
            onSuccessiveSave={(response) => navigate('/exlCourseDetails/' + response.course.id)}
            callback={filterComponents}
            isExl
        />
    );
};

export default DuplicateCourse;
